import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useFirebase } from "firebase";

/**
 * Returns true when the current user is an After staff member (`@after.com` email)
 * and has NOT opted into the `?view-as-customer` override.
 */
export function useIsCareSpecialist(): boolean {
  const { user: firebaseUser } = useFirebase();
  const location = useLocation();

  const viewAsCustomer = useMemo(
    () => new URLSearchParams(location.search).has("view-as-customer"),
    [location.search],
  );

  return useMemo(
    () =>
      !viewAsCustomer &&
      !!firebaseUser?.email &&
      firebaseUser.email.endsWith("@after.com"),
    [firebaseUser?.email, viewAsCustomer],
  );
}
